import { useCallback, useEffect, useState } from 'react';
import { Documentation } from 'types/documents';
import { getDocumentationsAssets, getDocumentationsModel } from 'services/documentation';

export const useGetDocumentGenerate = ({ roomId }: { roomId: number }) => {
  const [documentGenerate, setDocumentGenerate] = useState<Documentation[]>([]);

  const handleGetData = useCallback(async () => {
    if (!roomId) return;
    const [dataDocumentAsset, dataDocumentModel] = await Promise.all([
      getDocumentationsAssets({ roomId, page: 1, size: 1000 }),
      getDocumentationsModel({ roomId, page: 1, size: 1000 })
    ]);
    setDocumentGenerate([...dataDocumentAsset.documentations, ...dataDocumentModel.documentations]);
  }, [roomId]);

  useEffect(() => {
    handleGetData();
    const signal = new AbortController();
    document.addEventListener(
      'fresh:documentgenerate',
      () => {
        handleGetData();
      },
      { signal: signal.signal }
    );
    return () => {
      signal.abort();
    };
  }, [handleGetData]);
  return { documentGenerate };
};
